import { CommonModule } from "@angular/common";
import { Component, inject, OnInit, OnDestroy} from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { _getRowHeightAsNumber, ICellRendererParams } from "ag-grid-community";

import { ICellRendererAngularComp } from "ag-grid-angular";
import { UserService } from "@services/user.service";
import { Observable, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { ROLE_GROUPS } from "../../../constants/roles";

@Component({
  selector: 'app-edit-delete-renderer',
  imports: [MatIconModule, CommonModule],
  templateUrl: './edit-delete-renderer.component.html',
  styleUrl: './edit-delete-renderer.component.css'
})
export class EditDeleteRendererComponent implements ICellRendererAngularComp, OnInit, OnDestroy{

    private params!: ICellRendererParams;
    private destroy$ = new Subject<void>();
    private readonly userService = inject(UserService);
    
    showDelete = false;
    showCreate = false;
    showEdit = false;
    
    disableDelete = false;
    disableCreate = false;
    disableEdit = false;
    
    isProviderAlsoUser = false;
    canAddUserValue = false;
    isProviderActive = false;
    
    ngOnInit(): void {
      this.userService.hasRequiredRoles(ROLE_GROUPS.SUPER_USER)
        .pipe(takeUntil(this.destroy$))
        .subscribe(canAdd => {
          this.canAddUserValue = canAdd;
        });
    }
    
    ngOnDestroy(): void {
      this.destroy$.next();
      this.destroy$.complete();
    }
    
    agInit(params: ICellRendererParams): void {
      this.refresh(params);
    }
  
    refresh(params?: any): boolean {
      this.params = params;
      this.isProviderAlsoUser = params.data.providerUserId != null && params.data.providerUserId > 0;
      this.isProviderActive = params.data.active == 1;
      
      if(params.showDelete !== undefined) {
        this.showDelete = params.showDelete;
      }
      if(params.showEdit !== undefined) {
        this.showEdit = params.showEdit;
      }
      if(params.showCreate !== undefined) {
        this.showCreate = params.showCreate;
      }
      
      if(params.disableDelete !== undefined) {
        this.disableDelete = params.disableDelete;
      }
      if(params.disableEdit !== undefined) {
        this.disableEdit = params.disableEdit;
      }
      if(params.disableCreate !== undefined) {
        this.disableCreate = params.disableCreate;
      }
      
      return true;
    }
    
    isEditDisabled(): boolean {
      return this.disableEdit;
    }
    
    isCreateDisabled(): boolean {
      return this.disableCreate || this.isProviderAlsoUser || !this.isProviderActive;
    }
    
    isDeleteDisabled(): boolean {
      return this.disableDelete;
    }
}